import React from "react";
import { MdOutlineContentCopy } from "react-icons/md";

const CustomReadMore = ({
  readMore,
  index,
  displayText,
  className,
  numberOfCharactersToShow = 300,
  handleCopyDisplayText,
  handleToggleReadMore,
}) => {
  const isArray = Array.isArray(displayText);

  // Case 1: if it's an array of paragraphs
  if (isArray) {
    const paragraphsToShow = readMore?.[index] ? displayText : [displayText[0]]; // only show the first para before "Read More"

    return (
      <div className={className || ""}>
        {paragraphsToShow.map((para, i) => (
          <p key={i} className="mb-3">
            {para}
          </p>
        ))}
        {displayText.length > 1 && (
          <button
            onClick={handleToggleReadMore}
            className="text-baseBlueColor !cursor-pointer font-semibold !text-[11px]"
          >
            {readMore?.[index] ? "...Read Less" : "...Read More"}
          </button>
        )}
      </div>
    );
  }

  // Case 2: if Normal String
  return (
    <div>
      <p
        className={`text-[14px] font-lexend mt-1 break-words text-[#333333] leading-[20px] tracking-wide overflow-hidden ${
          className || ""
        }`}
      >
        {readMore?.[index]
          ? displayText
          : displayText?.slice(0, numberOfCharactersToShow)}{" "}
        {displayText?.length > numberOfCharactersToShow && (
          <button
            onClick={handleToggleReadMore}
            className="text-baseBlueColor !font-lexend !cursor-pointer font-semibold !text-[11px]"
          >
            {readMore?.[index] ? (
              <div>
                {handleCopyDisplayText && (
                  <span>
                    <MdOutlineContentCopy
                      className="text-gray-500 text-[14px]"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyDisplayText({ displayText });
                      }}
                    />
                  </span>
                )}{" "}
                ...Read Less
              </div>
            ) : (
              <div>...Read More</div>
            )}
          </button>
        )}
      </p>
    </div>
  );
};

export default CustomReadMore;
